import { getNestedValue } from './objectHandlers';
import { formatNumber } from './invoice';

/**
 * Procesa el valor de un campo basado en su configuración y el objeto de datos.
 * @param {Object} col - Configuración de la columna {id, type, ...}
 * @param {Object} item - El objeto con los datos (ej. una factura o usuario)
 * @param {Array} identificationTypes - (Opcional) Mapeo de tipos de ID
 */
export const getFieldContent = (col, item, identificationTypes = []) => {
    const rawValue = getNestedValue(item, col.id);

    if (col.type === 'money') {
        return formatNumber(item[col.id] || rawValue);
    }

    if (col.id === 'type_identification' && identificationTypes.length > 0) {
        return identificationTypes.find(type => type.value === item[col.id])?.label || 'Desconocido';
    }

    return rawValue ?? '-';
};